"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryDeletedContract = exports.CategoryUpdateContract = exports.CategoryCreatedContract = exports.CategoryEventDataContract = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const events_1 = require("@getgreenline/events");
class CategoryEventDataContract {
}
exports.CategoryEventDataContract = CategoryEventDataContract;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], CategoryEventDataContract.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], CategoryEventDataContract.prototype, "parentCategoryId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], CategoryEventDataContract.prototype, "colorHex", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], CategoryEventDataContract.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], CategoryEventDataContract.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)()
], CategoryEventDataContract.prototype, "complianceCategoryId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], CategoryEventDataContract.prototype, "platformComplianceCategoryId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], CategoryEventDataContract.prototype, "measurementType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], CategoryEventDataContract.prototype, "exitLabel", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)()
], CategoryEventDataContract.prototype, "lowInventoryThreshold", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], CategoryEventDataContract.prototype, "cannabisCategory", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], CategoryEventDataContract.prototype, "cannabisType", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)()
], CategoryEventDataContract.prototype, "isActive", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], CategoryEventDataContract.prototype, "imageUrl", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)()
], CategoryEventDataContract.prototype, "categoryLocationOverrides", void 0);
class CategoryCreatedContract extends events_1.EventContract {
    constructor(params) {
        super(params);
        this.category = events_1.GreenlineEvent.create(CategoryEventDataContract, params.category);
    }
}
exports.CategoryCreatedContract = CategoryCreatedContract;
class CategoryUpdateContract extends events_1.EventContract {
    constructor(params) {
        super(params);
        this.category = events_1.GreenlineEvent.create(CategoryEventDataContract, params.category);
    }
}
exports.CategoryUpdateContract = CategoryUpdateContract;
class CategoryDeletedContract extends events_1.EventContract {
    constructor(params) {
        super(params);
        this.category = events_1.GreenlineEvent.create(CategoryEventDataContract, params.category);
    }
}
exports.CategoryDeletedContract = CategoryDeletedContract;
//# sourceMappingURL=events.js.map